
import { NavigateFunction, useNavigate, useParams } from 'react-router';
import { State, To } from 'history';
import { useCurrentCompany } from './CurrentCompany';

export const useCompanyPath = () => {
  const currentCompany = useCurrentCompany();
  return (to: To) => {
    let newTo = to;
    if(typeof to === 'string'&& to.charAt(0) === '/') {
      if (currentCompany) {
        newTo = `/${currentCompany.slug}${to}`;
      }else {
        console.error(`Can't navigate as there is no current company`);
      }
    }
    return newTo;
  }
};

export type NavigateFn =  {
  (to: To, options?: {
    replace?: boolean;
    state?: State;
  }): void;
}
const useCompanyNavigation = () => {
  const reactRouterNavigate = useNavigate();
  const getCompanyPath = useCompanyPath();
  const navigate: NavigateFn= (to, options) => {
    const newTo = getCompanyPath(to);
    return reactRouterNavigate(newTo, options)
  };
  return navigate;
};
export default useCompanyNavigation;
